// extracted by mini-css-extract-plugin
export default {"root":"OrgsListTableCellLinks_root__LLRFP","list":"OrgsListTableCellLinks_list__+f3E2","placeHolderShimmer":"OrgsListTableCellLinks_placeHolderShimmer__eDBBj"};